var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bannerBox",style:({ background: _vm.config.bgColor })},[_c('div',{style:({ margin: _vm.config.chooseMargin == 0 ? '0px' : '0 13px' })},[_c('div',{staticClass:"img",style:({
            width: _vm.config.chooseMargin == 0 ? '371px' : '345px',
            borderRadius: _vm.config.chooseMargin == 0 ? '' : '10px'
        })},[_c('div',{staticClass:"imgBox",attrs:{"id":_vm.id}},[_c('img',{attrs:{"src":_vm.config.imgURL,"alt":""}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }